export default __webpack_public_path__ + "static/media/output-onlinegiftools.e1324382.gif";